export const transformFetchResponse = ({ body }) => ({ body: Object.values(body) });
